<template lang="pug">
  a.login(:href="linkOffice + '/site/login?lang='+lang", target="_blank" v-if="white")
    include ../../../assets/images/svg/login.svg
    .login__title {{ tr.menu.login }}

  a.login(:href="linkOffice + '/site/login?lang='+lang", target="_blank" v-else)
    img.login__img(src=`../../../assets/images/svg/login.svg`, alt="")
    .login__title.login__title_color_grey {{ tr.menu.login }}
</template>

<script>
export default {
  data () {
    return {
      section: 'header'
    }
  },
  computed: {
    linkOffice () {
      return process.env.VUE_APP_OFFICE
    }
  },
  props: {
    white: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
  .login {
    display: flex;
    align-items: center;

    fill: #fff;
    text-decoration: none;
    opacity: 0.7;

    &:hover {
      opacity: 1;
    }

    cursor: pointer;

    &__img {
      width: 30px;
      opacity: 0.7;

    }

    &__title {
      margin-top: 2px;

      border-bottom: 1px solid #fff;

      color: $second_color;
      line-height: 0.8;

      &_color_grey {
        border-bottom: 1px solid #858585;
        color: #858585;
        font-size: 16px;
      }

    }
  }
</style>
